module.exports = __webpack_public_path__ + "static/Group5994@2x-f3308a574c026974a1f7ee64b87ba848.png";